import service from '@/utils/request';

// 解散公会
export var dismissUnion = function dismissUnion(data) {
  return service({
    url: "/xcpOpsManager/union/dismissUnion",
    method: 'post',
    data: data
  });
};

//修改工会会长
export var modifyUnionMaster = function modifyUnionMaster(data) {
  return service({
    url: "/xcpOpsManager/union/modifyUnionMaster",
    method: 'post',
    data: data
  });
};

//修改工会名称
export var modifyUnionName = function modifyUnionName(data) {
  return service({
    url: "/xcpOpsManager/union/modifyUnionName",
    method: 'post',
    data: data
  });
};

//修改工会公告
export var modifyUnionNotice = function modifyUnionNotice(data) {
  return service({
    url: "/xcpOpsManager/union/modifyUnionNotice",
    method: 'post',
    data: data
  });
};

//获取工会列表
export var unionList = function unionList(data) {
  return service({
    url: "/xcpOpsManager/union/unionList",
    method: 'post',
    data: data
  });
};